<template>
  <a-drawer @close="close" :visible="addressModal" title="Select Deliverable Area" width="50%" class="modal" >
    <a-row :span="24" type="flex">
      <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" class="item">
        <div class="acea-row row-right row-middle">
          <a-checkbox v-model="iSselect" @change="allCheckbox">Select All</a-checkbox>
          <span class="empty padding-left-sm" @click="empty">Clear</span>
        </div>
      </a-col>
    </a-row>
    <a-row>
      <a-col
        :span="6"
        justify="center"
        class="item"
        v-for="(item, index) in cityList"
        :key="index">
        <a-checkbox v-model="item.checked" :disabled="item.disabled" :label="item.areaName" @change="checkedClick(index)">
          {{item.areaName}}
        </a-checkbox>
        <span class="red"><!--({{ (item.count || 0) + '/' + item.childNum }})--></span>
      </a-col>
    </a-row>
    <div class="foot-btn">
      <a-button @click="close" class="margin-right-sm">Cancel</a-button>
      <a-button type="primary" @click="confirm">OK</a-button>
    </div>
  </a-drawer>
</template>

<script>
import * as logistics from '@/api/logistics'
import { mapGetters } from 'vuex'
export default {
  name: 'city',
  props: {
    type: {
      type: Number,
      default: 1,
    },
    id: {
      id: [Number, String],
      default: 0,
    },
    selectArr: {
      type: Array,
      default: [],
    },
    otherSelectedArr: {
      type: Array,
      default: [],
    }
    // acityList: {
    //   type: Array,
    //   default: [],
    // }
  },
  data() {
    return {
      iSselect: false,
      addressModal: false,
      loading: false,
      cityList: [],
      totalNum: 0 // 存储所有的市的个数
    };
  },
  computed: {
    ...mapGetters(['acityList'])
  },
  watch: {
    addressModal(newVal) {
      if(newVal) {
        this.cityList = JSON.parse(JSON.stringify(this.acityList))
        // 先初始化所有项的 checked 属性为 false，使用 $set 确保响应式
        this.cityList.forEach((item, index) => {
          this.$set(item, 'checked', false)
        });
        // 然后根据 selectArr 设置选中状态
        if (this.selectArr.length > 0) {
          this.cityList.forEach((item, index) => {
            this.selectArr.forEach((item3, index3) => {
              if (item3.areaId === item.areaId) {
                this.$set(item, 'checked', true)
              }
            });
          });
        }
        /**otherSelectedArr 将其他已经选中的城市 置灰 */
        if(this.otherSelectedArr.length > 0) {
          this.cityList.forEach((item, index) => {
            this.otherSelectedArr.forEach((item3, index3) => {
              if (item.areaId === item3.areaId) {
                this.$set(this.cityList[index], 'disabled', true )
              }
            });
          });
        }
        // 更新全选状态
        this.$nextTick(() => {
          const checkedCount = this.cityList.filter(item => item.checked).length
          this.iSselect = checkedCount > 0 && checkedCount === this.cityList.length && this.otherSelectedArr.length === 0
        })
      }
    }
  },
  methods: {
    /**
     * 全选或者反选
     */
    allCheckbox: function () {
      this.cityList.forEach((item, index) => {
        this.$set(item, 'checked', true)
      })
      this.iSselect=true
      // this.render();
    },
    // 清空；
    empty() {
      this.cityList.forEach((item, index) => {
        this.$set(item, 'checked', false)
      })
      this.iSselect = false;
    },
    /**
     * 点击省
     * @param index
     */
    checkedClick: function (index) {
      let that = this;
      if (that.cityList[index].checked) {
        that.$set(that.cityList[index], 'checked', true);
      } else {
        that.$set(that.cityList[index], 'checked', false);
        that.iSselect = false;
      }
      // this.render();
    },
    /**
     * 点击市区,一个一个的选
     */
    // 确定选中的城市
    confirm() {
      let that = this;
      // 被选中的省市；
      let selectList = [];
      console.log('cityList',this.cityList)
      that.cityList.forEach(function (item, key) {
        let data = {};
        if (item.checked) {
          data = {
            areaName: item.areaName,
            areaId: item.areaId,
          };
        }

        if (data.areaId !== undefined) {
          selectList.push(data);
        }
      });
      if (selectList.length === 0) {
        return that.$message.error('Please select at least one province or city');
      } else {
        window.console.log('selectList',selectList)
        console.log('selectArr',this.selectArr)
        console.log('otherSelectedArr',this.otherSelectedArr)
        /**全选处理
         * 1、虽然点击了全选按钮，但是其他可配送区域(otherSelectedArr)已经选过城市，此时不是全选
         * 2、点击全选按钮，取消掉一个城市，此时不是全选
         */
        let selectedCityNum = 0, isAllSelect = true
        selectList.forEach((item)=>{
          selectedCityNum++
        })
        this.totalNum = this.cityList.length;
        console.log('选中的城市数量 selectedCityNum',selectedCityNum)
        console.log('所有城市数量 totalNum',this.cityList.length)
        if(this.otherSelectedArr.length > 0) {
          isAllSelect = false
        }else{
          if(selectedCityNum != this.totalNum){
            isAllSelect = false
          }
        }
        /*************************************************************/
        this.$emit('selectCity', {
          id: this.id,
          selectList: selectList,
          type: this.type, // 0添加 1编辑
          isEdit: this.selectArr.length ? true : false,
          iSselect: isAllSelect
        });
        that.addressModal = false;
        this.cityList = [];
      }
    },
    close() {
      this.addressModal = false;
      this.cityList = [];
    },


  }
};
</script>

<style scoped lang="less">
.modal .item {
  margin-bottom: 20px;
  position: relative;
}

.modal .item .city {
  position: absolute;
  z-index: 9;
  top: 17px;
  padding-top: 18px;
}

.modal .item .city .checkBox {
  width: 97%;
  padding: 10px;
  border: 1px solid #eee;
  background-color: #fff;
  max-height: 100px;
  overflow-x: hidden;
  overflow-y: auto;
}

.modal .item .city .checkBox .arrow {
  position: absolute;
  top: 3px;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-bottom-color: #ddd;
}

.modal .item .city .checkBox .arrow:before {
  position: absolute;
  bottom: -8px;
  right: -7px;
  content: '';
  width: 0;
  height: 0;
  border: 7px solid transparent;
  border-bottom-color: #fff;
}

.modal .item .city .checkBox .itemn {
  margin-bottom: 10px;
}

.radio {
  padding: 5px 0;
  font-size: 14px !important;
}

.red {
  color: #ff0000;
}

.empty {
  cursor: pointer;
}
</style>
